export default function Meta({ children, className = "" }) {
  return (
    <span className={`font-sans text-meta uppercase text-text-tertiary ${className}`}>
      {children}
    </span>
  );
}
